import ExpandedMessage from '../ExpandedMessage/ExpandedMessage'
import MessageCard from '../MessageCard/MessageCard'
import { HomeMessage, MessageLabels, MessageRowView } from '../types'

interface MessageRowProps {
  row: MessageRowView
  labels: MessageLabels
  onToggle: (message: HomeMessage) => void
}

const MessageRow = ({ row, labels, onToggle }: MessageRowProps) => (
  <>
    {row.messages.map(message => (
      <MessageCard
        key={message.id}
        message={message}
        expanded={message.id === row.expanded?.id}
        labels={labels}
        onToggle={onToggle}
      />
    ))}
    <ExpandedMessage hidden={row.expanded === null} message={row.expanded} labels={labels} onToggle={onToggle} />
  </>
)

export default MessageRow
